export const DistroActionTypes = {
  SET_CURRENT_DISTRO: "SET_CURRENT_DISTRO",
};
